import  incidencesData from "../pages/Dashboard/lib/data.json"
export const fetchIncidents = async () => {
    // Use this when Api is ready
    // const response = await fetch('https://api.restful-api.dev/objects');
    // await response.json();
    return incidencesData
};